import { FC } from "react";

type ResolutionArrowDropdownT = {
  className: string;
};
export const ResolutionArrowDropdown: FC<ResolutionArrowDropdownT> = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#F6F7FD"
      d="m8.81 7.742-3.826 3.825a.833.833 0 1 0 1.184 1.175l3.816-3.834a.833.833 0 0 1 1.184 0l3.816 3.834a.834.834 0 0 0 1.184-1.175l-3.825-3.825a2.5 2.5 0 0 0-3.534 0Z"
    />
  </svg>
)